import React, { useEffect, useState, useMemo } from "react";
import { useApi } from "../../hooks/useApi";
import DmeLogFilters from "./DmeLogFilters";
import DmeLogTable from "./DmeLogTable";
import DmeLogDetail from "./DmeLogDetail";
import { useMsal } from "@azure/msal-react";

const DmeLogPage = () => {
    const { get } = useApi();
    const { accounts } = useMsal();
    const user = accounts[0];
    const userEmail = user?.username;


    const today = new Date().toISOString().slice(0, 10);

    // filtros �de consulta�
    const [filters, setFilters] = useState({
        chain: "",
        from: today,
        to: today,
    });

    // datos y UI states
    const [userChains, setUserChains] = useState([]);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]); // todos los registros de la consulta (sin paginar)
    const [summary, setSummary] = useState({ successCount: 0, errorCount: 0, naCount: 0 });

    // paginaci�n/b�squeda (client-side)
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [q, setQ] = useState("");

    // detalle
    const [selectedId, setSelectedId] = useState(null);
    const [detail, setDetail] = useState(null);

    // cadenas permitidas
    useEffect(() => {
        const fetchChains = async () => {
            if (!userEmail) return;
            try {
                const res = await get("chainsByUserEmail", { urlParams: { id: userEmail } });
                const chains = (res || []).map((c) => c.chain).filter(Boolean);
                setUserChains(chains);
            } catch {
                setUserChains([]);
            }
        };
        fetchChains();
    }, [userEmail, get]);

    // qu� cadenas consultar: seleccionada o todas las permitidas
    const chainsToQuery = useMemo(() => {
        if (filters.chain && filters.chain.trim() !== "") return [filters.chain.trim()];
        return userChains;
    }, [filters.chain, userChains]);

    // carga de datos (trae TODO lo del rango seleccionado y se pagina en el cliente)
    const loadList = async () => {
        if (!chainsToQuery.length) return;
        setLoading(true);
        try {
            const res = await get("ListaDmeLog", {
                params: {
                    chain: chainsToQuery.join(","),
                    from: filters.from,
                    to: filters.to,
                    page: 1,
                    pageSize: 20000, // trae suficiente para paginar client-side (ajusta seg�n tu techo)
                },
            });
            // Soportamos respuesta {items, successCount...} o un array directo
            const arr = Array.isArray(res) ? res : res.items || [];
            setItems(arr);
            setSummary({
                successCount: res?.successCount ?? 0,
                errorCount: res?.errorCount ?? 0,
                naCount: res?.naCount ?? 0,
            });
            setPage(1); // reset page al cambiar de consulta
        } finally {
            setLoading(false);
        }
    };

    // primera carga al tener cadenas
    useEffect(() => {
        if (userChains.length === 0) return;
        loadList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userChains]);

    // recargar al cambiar filtros de consulta (no por cambios de page/pageSize/q)
    useEffect(() => {
        if (chainsToQuery.length === 0) return;
        loadList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.from, filters.to, chainsToQuery.join(",")]);

    const handleSearchFilters = (newFilters) => {
        setFilters((prev) => ({ ...prev, ...newFilters }));
    };

    const loadDetail = async (id) => {
        const res = await get("DetalleDmeLog", { urlParams: { id } });
        setSelectedId(id);
        setDetail(res);
    };

    const handleBack = () => {
        setSelectedId(null);
        setDetail(null);
    };

    return (
        <div className="p-6">
            <h2 className="text-xl font-semibold mb-4">Consulta de logs DME</h2>

            {!selectedId ? (
                <>
                    <DmeLogFilters
                        onSearch={handleSearchFilters}
                        current={{ ...filters }}
                        availableChains={userChains}
                    />

                    <DmeLogTable
                        // datos (sin paginar)
                        items={items}
                        summary={summary}
                        loading={loading}
                        // acciones
                        onDetail={loadDetail}
                        // paginaci�n/b�squeda client-side
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        q={q}
                        setQ={setQ}
                        userEmail={userEmail}
                        chain={filters.chain}        
                        from={filters.from} 
                        to={filters.to} 
                    />
                </>
            ) : (
                <DmeLogDetail data={detail} onBack={handleBack} />
            )}
        </div>
    );
};

export default DmeLogPage;